<script>
import QuestionForm from "@/views/Evaluation/File/Components/QuestionForm.vue";
import CriteriaForm from "@/views/Evaluation/File/Components/CriteriaForm.vue";
import useSharedData from "@/use/SharedData";
import {onMounted, ref} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    components: {QuestionForm, CriteriaForm},
    props: {
        type: String,
    },
    setup(props) {
        const {getBack} = useSharedMethod();
        const {dialog, loading} = useSharedData();

        const evaluationFile = ref({
            preSelectedNote: false,
            activateTarget: false,
            activateCategoryGravity: false,
            activateCriterionGravity: false,
            isPercent: false,
            categories: [],
            questions: []
        });

        function getDefaultValues() {
            loading.value = true;
            axios.get(`/evaluationFiles/defaultValues/${props.type}`).then(response => {
                evaluationFile.value.preSelectedNote = response.data.preSelectedNote;
                evaluationFile.value.activateTarget = response.data.activateTarget;
                evaluationFile.value.activateCategoryGravity = response.data.activateCategoryGravity;
                evaluationFile.value.activateCriterionGravity = response.data.activateCriterionGravity;
                evaluationFile.value.isPercent = response.data.isPercent;
            }).finally(() => {
                loading.value = false;
            });
        }

        function add() {
            loading.value = true;
            axios.put(`/evaluationFiles/addBulk/${props.type}`, evaluationFile.value).then(() => {
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => {
            getDefaultValues();
        });

        return {
            dialog,
            loading,
            evaluationFile,
            add,
            getBack
        }
    }
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="1200"
            scrollable
        >
            <v-card>
                <w-toolbar color="teal" :title="$t('common.multiple_addition')"/>
                <v-card-text>
                    <v-container fluid>
                        <criteria-form
                            v-model="evaluationFile.categories"
                            :activate-category-gravity="evaluationFile.activateCategoryGravity"
                            :activate-criterion-gravity="evaluationFile.activateCriterionGravity"
                            :activate-target="evaluationFile.activateTarget"
                            :preSelectedNote="evaluationFile.preSelectedNote"
                            :type="type"
                        />
                        <br/>
                        <question-form
                            v-model="evaluationFile.questions"
                        />
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                    <w-btn-add
                        show
                        :loading="loading"
                        @press="add"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <router-view/>
    </div>
</template>

<style scoped>

</style>